"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signUpUtils = exports.propNames = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
const location_1 = require("src/location");
const String_utils_1 = require("src/String.utils");
exports.propNames = {
    key: 'key',
    value: 'value',
};
class SignUpUtils {
    constructor() {
        this.countryWithLanguages = [
            {
                code: 'BE',
                languages: ['FR', 'NL'],
            },
            {
                code: 'CH',
                languages: ['DE', 'FR'],
            },
        ];
        this.formatLanguages = (languages) => {
            if (!languages || !languages.length) {
                return;
            }
            return this.countryWithLanguages.reduce((acc, country) => {
                const langOptions = languages.filter(language => {
                    return country.languages.some(langCode => (0, String_utils_1.equalIgnoreCase)(langCode, language.value));
                });
                acc[country.code] = langOptions;
                return acc;
            }, {});
        };
        this.formatInputs = (inputFields, genericFields, specificFields) => {
            return Object.keys(inputFields).map((key) => {
                const value = inputFields[key];
                return {
                    errorMessage: genericFields[value + 'ValidationMessage'] ||
                        genericFields[value + 'ValidationMessageEmpty'] ||
                        specificFields[value + 'ValidationMessage'] ||
                        specificFields[value + 'ValidationMessageEmpty'] ||
                        '',
                    formatErrorMessage: genericFields[value + 'ValidationMessageIncorrectFormat'],
                    emailInfoErrorMessage: genericFields[value + 'ValidationMessageIncorrectFormatStartsWithInfo'],
                    embargoCountryErrorMessage: genericFields[value + 'WarningMessageEmbargoCountry'],
                    hint: genericFields[value + 'Info'] || specificFields[value + 'Info'] || '',
                    label: genericFields[value + 'Label'] || specificFields[value + 'Label'] || '',
                    name: key,
                    placeholder: genericFields[value + 'Placeholder'] || specificFields[value + 'Placeholder'] || '',
                    propName: key,
                    required: true,
                };
            });
        };
    }
    createCountryService(apiUrl, culture, locationApiKey) {
        return new location_1.CountryService({
            apiUrl,
            culture,
            keyMode: location_1.LocationKeyModeEnum.Code,
            prefixNeeded: false,
            locationApiKey,
        });
    }
    convertLanguages(languages) {
        if (!languages || !languages.length) {
            return;
        }
        return languages.map(({ key, value }) => {
            return {
                title: value,
                value: key,
            };
        });
    }
    getFormData(apiUrl, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return (0, app_1.api)(apiUrl, pageId).then(response => response.data);
        });
    }
}
exports.signUpUtils = new SignUpUtils();
